export default __webpack_public_path__ + "static/media/deleteImageIcon.b1efd28a.webp";